import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
var colour = variables.colour;
export var suburbArticles = {
  name: "1qm1lh",
  styles: "margin-bottom:16px;"
};
export var title = /*#__PURE__*/css(typography.headingCaps, " color:", colour.neutral500, ";margin-bottom:16px;");